module.exports = __webpack_public_path__ + "static/media/vaneyk-8.71b34ce2.jpeg";